/** The employee page's editable fields (#5775). */
export interface EmployeeAccountFormModel {
  advanceGlAccountReference: string | null;
  apGlAccountReference: string | null;
  isActive: boolean;
}

export const employeeAccountFieldLabels: Record<keyof EmployeeAccountFormModel, string> = {
  advanceGlAccountReference: 'EmployeeAccount_Details_Form_Field_AdvanceAccount',
  apGlAccountReference: 'EmployeeAccount_Details_Form_Field_ApAccount',
  isActive: 'EmployeeAccount_Details_Form_Field_IsActive',
};
